export const getQueryParam = (key: string, search: string): string | null => {
  const params = new URLSearchParams(search);
  return params.get(key);
};
